<style lang="css">

</style>

<template lang="html">
<el-form
    v-form
    :model="carExhibitionProductForm"
    editAction="carShow/business/updateProduct.action"
    addAction= "carShow/business/insertProduct.action"
    selectAction="carShow/business/selectProductInfo.action"
    :rules="rules" label-width="120px">
    <el-form-item label="商品名称：" prop="name">
        <el-input v-model="carExhibitionProductForm.name" placeholder="请简要输入（限制20字）"></el-input>
    </el-form-item>
    <el-form-item label="商品描述：" prop="describes">
        <el-input type="textarea" v-model="carExhibitionProductForm.describes" placeholder="请输入优惠 赠品等信息（限制200字）"></el-input>
    </el-form-item>
    <el-form-item label="上传封面图片：" prop="image">
      <el-upload
        v-model="carExhibitionProductForm.image"
        :action="baseUrl+'upload/uploadPic'"
        :data="{floder:'carExhibition'}"
        :show-file-list="false"
        class="avatar-uploader">
          <img v-if="carExhibitionProductForm.image&&carExhibitionProductForm.image.url" :src="carExhibitionProductForm.image.url" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
        <div style="color:#999">支持jpg、png图片格式，750*460px，<span style="color:red">最多1张</span></div>
    </el-form-item>
    <el-form-item label="上传更多图片：" prop="introductionImage">
      <el-upload
          multiple
          :file-list="carExhibitionProductForm.introductionImage"
          v-model="carExhibitionProductForm.introductionImage"
          :action="baseUrl+'upload/uploadPic'"
          :data="{floder:'carExhibition'}"
          :limit="9"
          list-type="picture-card">
          <i class="el-icon-plus"></i>
      </el-upload>
      <div style="color:#999">支持jpg、png图片格式，750*460px，<span style="color:red">最多9张，用于商家详情顶部展示！</span></div>
    </el-form-item>
    <el-form-item label="商品详细介绍：" prop="detailedDescribe">

        <wang-edit ref="wang-edit" style="width:40%" @change="onEidtChange"></wang-edit>

    </el-form-item>
    <el-form-item>
        <el-button type="primary">保存</el-button>
    </el-form-item>
</el-form>

</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
import WangEdit from '@/components/WangEdit'
export default {
  extends: BasicPager,
  components: {
    WangEdit
  },
  data: function () {
    return {
      baseUrl: Config.baseUrl,
      carExhibitionProductForm: {
        image: null,
        introductionImage: [],
        detailedDescribe: null
      },
      rules: {
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { max: 20, message: '商品名称最多20字以内', trigger: 'blur' }
        ],
        describes: [
          { required: true, message: '请输入商品描述', trigger: 'blur' },
          { max: 200, message: '描述最多200字以内', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '请上传封面图片', trigger: 'change' }
        ],
        introductionImage: [
          { required: true, message: '请上传更多图片', trigger: 'change' }
        ],
        detailedDescribe: [
          { required: true, message: '请输入商品详细介绍', trigger: 'blur' }
        ]
      }
    }
  },
  created: function () {
    let params = this.$route.params
    if (params.businessId) {
      this.carExhibitionProductForm.businessId = params.businessId
    }

    if (params.id) {
      this.carExhibitionProductForm.id = params.id
    }
  },
  methods: {
    onSelectInfo: function (dataInfo) {
      let params = dataInfo.datas
      this.$refs['wang-edit'].setContent(params.detailedDescribe)
    },
    onEidtChange: function (html) {
      this.$set(this.carExhibitionProductForm, 'detailedDescribe', html)
    }
  }
}

</script>
